import React, { useState } from "react";
import {
  CognitoUser
} from "amazon-cognito-identity-js";

import UserPool from "../cognitoConfig";

import { useNavigate } from "react-router-dom";
import Button from "react-bootstrap/Button";
import AuthLayout from "../Components/AuthLayout/AuthLayout";


const ForgotPassword = () => {

    const [email, setEmail] = useState("");
  
    const navigate = useNavigate();
  
    const [codeSent, setCodeSent] =
      useState(false);
  
    const [verificationCode, setVerificationCode] =
      useState("");
  
    const [newPassword, setNewPassword] =
      useState("");
  
    const resetPassword = () => {

        if (verificationCode.includes(" ")) {
      
          alert(
            "The verification code contains spaces. Please remove any spaces and try again."
          );
      
          return;
        }
      
        const user =
          new CognitoUser({
            Username: email,
            Pool: UserPool
          });
      
        user.confirmPassword(
          verificationCode,
          newPassword,
          {
            onSuccess() {
      
              alert(
                "Password reset successful"
              );
      
              navigate("/login");
            },
      
            onFailure(err) {
      
              alert(
                err.message
              );
            }
          }
        );
      };
  
    const sendCode = () => {

        const user =
          new CognitoUser({
            Username: email,
            Pool: UserPool
          });
      
        user.forgotPassword({
      
          onSuccess() {
            alert("Success");
          },
      
          onFailure(err) {
            alert(err.message);
          },
      
          inputVerificationCode() {
      
            setCodeSent(true);
      
            alert(
              "Verification code sent"
            );
          }
        });
      };

    return (
        <AuthLayout>
            <form>

                <h2 className="mb-4">
                Forgot Password
                </h2>

                {!codeSent ? (
                <>
                    <div className="form-group">
                    <label>Email Address</label>

                    <input
                        type="email"
                        placeholder="Enter your email"
                        value={email}
                        onChange={(e) => setEmail(e.target.value)}
                        required
                    />
                    </div>

                    <Button
                    className="btn btn-primary"
                    variant="primary"
                    onClick={sendCode}
                    >
                    Send Verification Code
                    </Button>
                </>
                ) : (
                <>
                    <div className="form-group">
                    <label>Verification Code</label>

                    <input
                        type="text"
                        placeholder="Enter verification code"
                        value={verificationCode}
                        onChange={(e) =>
                        setVerificationCode(e.target.value)
                        }
                    />
                    </div>

                    <div className="form-group">
                    <label>New Password</label>

                    <input
                        type="password"
                        placeholder="Enter new password"
                        value={newPassword}
                        onChange={(e) =>
                        setNewPassword(e.target.value)
                        }
                    />
                    </div>

                    <Button
                    className="btn btn-primary"
                    variant="primary"
                    onClick={resetPassword}
                    >
                    Reset Password
                    </Button>
                </>
                )}

                <div className="create-account">
                <span
                    style={{ cursor: "pointer" }}
                    onClick={() => navigate("/login")}
                >
                    Back to Login
                </span>
                </div>

            </form>
            </AuthLayout>
      );
};

export default ForgotPassword;